






















import Vue from "vue";
import IconButton from "./IconButton.vue";

export default Vue.extend({
  props: {
    src: { type: String, default: '' },
    openOnNewPageButton: { type: Boolean, default: true },
    showExitButton: { type: Boolean, default: true },
  },

  components: {
    IconButton,
  },

  data() {
    return {
      currentPage: 1,
      pageCount: 1,
    };
  },

  methods: {
    async openOnNewPage() {
      window.open(this.src);
    },

    exitPdf() {
      this.$emit("exit");
    },
  },
});
